// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"AsSeenIn_Wrapper__nqvAh","ImgsWrapper":"AsSeenIn_ImgsWrapper__TntqA","ImgContainer":"AsSeenIn_ImgContainer__QUG_E"};